<template>
  <ThemeProvider :theme="currentTheme">
    <nuxt />
  </ThemeProvider>
</template>

<script>
import {
  ThemeProvider,
  createThemeFromSettings,
} from '@campsite-bio/component-lib';
import { computed, useStore } from '@nuxtjs/composition-api';

export default {
  components: {
    ThemeProvider,
  },

  setup() {
    const store = useStore();

    const theme = computed(() => {
      if (!store.getters.hasCampsite) return 'profile';

      return createThemeFromSettings(store.state.campsite, 'profile');
    });

    return { currentTheme: theme };
  },
};
</script>

<style lang="scss"></style>
